// BankBridge.jsx
import { useEffect, useMemo, useRef, useState } from 'react'
import Lottie from 'lottie-react'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'

/**
 * Props:
 *  - state: 'idle' | 'starting' | 'running' | 'done' | 'error'
 *  - intervalMs?: número en ms entre mensajes (default 900)
 */
export default function BankBridge({ state = 'running', intervalMs = 900 }) {
  // Mensajes solicitados
  const ALL_STEPS = useMemo(
    () => [
      'Conectando con tu banco de manera segura…',
      'Estableciendo comunicación con Fintoc…',
      'Accediendo a la información de tu cuenta…',
      'Solicitando los movimientos bancarios más recientes…',
      'Recuperando tus transacciones desde el banco…',
      'Procesando los datos recibidos…',
      'Verificando la información descargada…',
      'Guardando tus movimientos en TryLuca…',
      'Organizando los registros en tu panel…',
      '¡Listo! Tus movimientos ya están disponibles.',
    ],
    []
  )

  // Los pasos “en curso” (todo menos el último, que es sólo para `done`)
  const RUN_STEPS_LAST_INDEX = ALL_STEPS.length - 2

  const [idx, setIdx] = useState(0)
  const timerRef = useRef(null)

  // Avance por tiempo mientras no esté "done" ni "error"
  useEffect(() => {
    // reset a inicio si arrancamos/relanzamos
    if (state === 'starting') setIdx(0)

    if (state === 'done' || state === 'error') {
      if (timerRef.current) clearInterval(timerRef.current)
      timerRef.current = null
      return
    }

    // starting / running: avanzar cada intervalMs hasta el penúltimo mensaje
    timerRef.current = setInterval(() => {
      setIdx(prev => (prev < RUN_STEPS_LAST_INDEX ? prev + 1 : RUN_STEPS_LAST_INDEX))
    }, intervalMs)

    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
      timerRef.current = null
    }
  }, [state, intervalMs])

  // Mensaje activo (si `done`, mostrar el último)
  const activeText =
    state === 'done' ? ALL_STEPS[ALL_STEPS.length - 1] : ALL_STEPS[idx]

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-6 p-6 text-center">
      {/* Loader mientras no esté 'done' ni 'error' */}
      {state !== 'done' && state !== 'error' && (
        <Lottie animationData={LoaderAdm} loop style={{ width: 220, height: 220 }} />
      )}

      {/* Mensaje activo */}
      <div className="max-w-2xl">
        <p className="text-lg md:text-xl text-gray-800 font-medium">{activeText}</p>
      </div>

      {/* Estado de error (opcional) */}
      {state === 'error' && (
        <p className="text-red-600 text-sm">
          Ocurrió un problema durante la sincronización inicial. Intenta nuevamente.
        </p>
      )}
    </div>
  )
}
